import { queueVariantOf } from "@app/protocol";
import { normalizeRules } from "@app/rules";
import { DEFAULT_GOALS, lengthFor, STANDARD_LENGTH } from "./seats";
import { createTable, SEAT_COUNT, seatedCount } from "./state";
/** What every table "Find players" fills plays (decision 128): the game's target, normal tempo, standard rules. */
export function standardSettings(variant) {
    return {
        variant,
        goal: DEFAULT_GOALS[variant],
        length: lengthFor(variant, STANDARD_LENGTH),
        tempo: "normal",
        rules: normalizeRules(variant, {}),
    };
}
/**
 * A table the queue formed (review 0020, decision 128): standard settings, listed for "Find
 * players", nobody's to change.
 */
export function createQueueTable(id, variant, now) {
    return { ...createTable(id, standardSettings(variant), now), queue: true };
}
/**
 * A channel's table opens its empty seats to "Find players" (decision 126 A): it takes the game's
 * standard settings, like every table the queue fills, and is listed; closing keeps the settings.
 * A table the queue formed stays open. Owner only, lobby only.
 */
export function setQueue(state, userId, open, now) {
    const fail = (code) => [{ type: "error", userId, code }];
    if (state.owner !== userId)
        return fail("not-owner");
    if (queueVariantOf(state.id) !== null)
        return fail("queue-table");
    // Four seated starts the countdown: a full table has no seat to give.
    if (open && seatedCount(state) === SEAT_COUNT)
        return fail("no-empty-seat");
    if (state.status !== "lobby")
        return fail("not-lobby");
    if (open) {
        state.settings = standardSettings(state.settings.variant);
        state.listed = true;
    }
    state.queue = open;
    state.lastActivityAt = now;
    return [{ type: "broadcast" }];
}
//# sourceMappingURL=queue.js.map